var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-20"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/my' }}},[_vm._v("个人主页")]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.title))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }